import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI, setAuthToken } from '@/services/api';
import { toast } from 'sonner';
import { Lock, User, ArrowLeft } from 'lucide-react';
import Logo from '@/components/Logo';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await authAPI.login(formData.username, formData.password);
      setAuthToken(response.data.access_token);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F8FA] flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full">
        <div className="flex justify-center mb-8">
          <Logo size="lg" />
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-md p-8">
          <h1 className="text-2xl font-bold text-slate-900 mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Espace administrateur
          </h1>
          <p className="text-slate-500 text-sm mb-6">Connectez-vous pour gérer le garage</p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="form-label">Nom d'utilisateur</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
                <input
                  name="username"
                  value={formData.username}
                  onChange={handleInputChange}
                  placeholder="admin"
                  className="form-input pl-10"
                  required
                  disabled={isLoading}
                  data-testid="admin-username"
                />
              </div>
            </div>

            <div>
              <label className="form-label">Mot de passe</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
                <input
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="••••••••"
                  className="form-input pl-10"
                  required
                  disabled={isLoading}
                  data-testid="admin-password"
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full btn-primary"
              disabled={isLoading}
              data-testid="admin-login-submit"
            >
              {isLoading ? 'Connexion…' : 'Se connecter'}
            </button>
          </form>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-blue-900 text-sm transition-colors">
            <ArrowLeft size={14} />
            Retour au site
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
